export default {"src":"/_next/static/media/blackChevron.406634ad.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};